import React from 'react';

const Settings = () => {
    return (
        <div>
            Yahoo
        </div>
    );
};

export default Settings;